import React from "react";
import { FiArrowRight, FiCalendar, FiClock, FiSearch } from "react-icons/fi";

const Blog = () => {



  return (
    <div className="bg-white text-gray-900">
      <div className="flex justify-center items-center h-40">
        <h2>Coming Soon</h2>
      </div>
    </div>
  );
};

export default Blog;
